import { FormGroup } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DonHangMua, DonHangMuaChiTiet, HistoryLogBodyDto } from '../don-hang-mua-page-model/don-hang-mua.model';
import { FileImport } from '../../../mua-hang/ke-hoach-hang-ve/ke-hoach-hang-ve-model/ke-hoach-hang-ve.model';
const API_ROOT_URL = environment.ApiRoot + '/donhangmua';
const API_ROOT_URL_DC = environment.ApiRoot + '/dungchung';

@Injectable()
export class DonHangMuaService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'desc', 'NGAYLAPPHIEU', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'desc', 'NGAYLAPPHIEU', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<FileImport> = new BehaviorSubject(null);
	dataFormGroup$: BehaviorSubject<any> = new BehaviorSubject({});
	dataListItem$: BehaviorSubject<any> = new BehaviorSubject([]);
	dataListFileDinhKem$: BehaviorSubject<any> = new BehaviorSubject([]);
	dataListFileBangChung$: BehaviorSubject<any> = new BehaviorSubject([]);
	dataFile$:  BehaviorSubject<FileImport> = new BehaviorSubject(null);
	dataListPTTT$: BehaviorSubject<any> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/ListOrder', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	listLichSuGiaoHang(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/LichSuGiaoHang', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	insertOrder(item: DonHangMua): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/InsertOrder', item, { headers: httpHeaders });
	}

	editOrder(item: DonHangMua): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DonHangMua>(API_ROOT_URL+'/EditOrder', item, { headers: httpHeaders });
	}

	detailOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<DonHangMua>(API_ROOT_URL+`/DetailOrder?Id=${item}`, { headers: httpHeaders });
	}

	deleteOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<DonHangMua>(API_ROOT_URL+`/DeleteOrder?Id=${item}`, { headers: httpHeaders });
	}

	KeHoachMuaHangTemp(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/KeHoachMuaHangTemp?IdNCC=${item}`, { headers: httpHeaders });
	}

	changeStatusOrder(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DonHangMua>(API_ROOT_URL+'/ChangeStatusOrder', item, { headers: httpHeaders });
	}

	acceptOrder(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/AcceptOrder', item, { headers: httpHeaders });
	}

	rejectOrder(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/RejectOrder', item, { headers: httpHeaders });
	}

	listSuggestion(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/ListSuggestion', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	getNumberHoanTat(queryParams: QueryParamsModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/GetNumberHoanTat', {
			headers: httpHeaders,
			params: httpParams
		});
	}


	listHistory(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/ListOrder_FilterGood', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	LichSuGiaMuaHang(data: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/LichSuGiaMuaHang', data , {
			headers: httpHeaders
		});
	}

	// downloadTemplate(Id: any): string {
	// 	return API_ROOT_URL + `/DownLoadFileBangChungNCC?IdDHM=${Id}`;
	// }

	downloadTemplate(IdAttachment: number): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("IdAttachment", IdAttachment.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/DownLoadFile', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	  }

	listDiaDiemGiaoHang(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<DonHangMua>(API_ROOT_URL+`/ListDiaDiemGiaoHang`, { headers: httpHeaders });
	}

	getChiTietDuyetDonHangMua(IdCt: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("IdCt", IdCt.toString());
		return this.http.get<any>(API_ROOT_URL+`/GetDetailOrder`, { headers: httpHeaders, params: httpParams });
	}

	setChiTietDuyetDonHangMua(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/AcceptOrderDetail', data , {
			headers: httpHeaders
		});
	}

	setFileBangChung(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/UploadFileBangChungNCC', data , {
			headers: httpHeaders
		});
	}

	removeFileBangChung(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/XoaFileBangChungNCC', data , {
			headers: httpHeaders
		});
	}

	HanMucPhongBan_Multiple(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL_DC + '/HanMucPhongBan_Multiple', data , {
			headers: httpHeaders
		});
	}

	HanMucDuyetPhongBan_Multiple(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL_DC + '/HanMucDuyetPhongBan_Multiple', data , {
			headers: httpHeaders
		});
	}

	getId(Idct): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DHM_Get_IDMaster?Idct=${Idct}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	getListHopDong(IdNCC: number = 0): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/ListContract?IdNCC=${IdNCC}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	fillDetail(IdHD: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DetailContract?IdHD=${IdHD}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	getDetailsKHMHWithListId(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/GetDetailsKHMHWithListId', data , {
			headers: httpHeaders
		});
	}

	openPO(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/OpenPO', item, { headers: httpHeaders });
	}

	exportFileExcel(Id): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(`${API_ROOT_URL}/DonHangMua_Export?Id=${Id}`, {
			headers: httpHeaders,
			responseType: 'blob' as 'json'
		});
	}

  approval(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/approval', data , {
			headers: httpHeaders
		});
	}

  selectedApproval(purchaseOrderId: number, request: { MethodApproval: string, SelectedUserApproval: number }): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(`${API_ROOT_URL}/approval/${purchaseOrderId}/selected-approval`, request, {
        headers: httpHeaders
    });
  }

  fetchHistoriesChange(purchaseOrderId: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(`${API_ROOT_URL}/${purchaseOrderId}/history`, {
			headers: httpHeaders
		});
  }

  createChangeQuantityAndPrice(purchaseOrderId: number, request: any): Observable<any> {
    console.log(purchaseOrderId, request);
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(`${API_ROOT_URL}/${purchaseOrderId}/history`, request, {
        headers: httpHeaders
    });
  }

  getReferences(purchaseOrderId: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(`${API_ROOT_URL}/${purchaseOrderId}/references`, {
      headers: httpHeaders
    });
  }

  export(id: number): Observable<Blob> {
    const headers = this.httpUtils.getHTTPHeaders();
  
    return this.http.get(`${API_ROOT_URL}/${id}/export`, {
      headers,
      responseType: 'blob'
    });
  }
}
